function restriction(){
  $(".js-ntf-restriction-modal").on("click", function() {
    $.modal({
      open: 'ntf-restriction-modal',
      triggerOpen: true,
      onClose: function() {
        $.modal({
          open: 'ntf-toast--new',
          triggerOpen: true
        })
      }
    });
  })
}

// checks toast email address
function toastEmailCheck() {
  var input = $('#ntf-email-address');
  var value = input.val();
  // checks if email exists
  if (value == 'test@revolve.com') {
    $.modal({
      open: "ntf-toast--existing",
      triggerOpen: true,
      type: "toast"
    });
  } else if (value == 'new@revolve.com') {
    // checks new email
    $.modal({
      open: "ntf-toast--new",
      triggerOpen: true,
      type: "toast"
    });
  } else {
    // checks error for input field
    // back end to update error state
    input.closest('.field').addClass('is-error');
  }
}

// NTF mobile toast function
function toast() {
    var $toast = $('.ntf-toast--btn');
    var $close = $('.ntf-toast--btn-close');
    $close.on('click', function() {
        $toast.hide();
  });

  // email sign up form
  $('.ntf-toast--form').on('submit', function(event){
    event.preventDefault();
    toastEmailCheck();
  });

  $(window).on("scroll resize", function () {
      var $window = $(this);
      var docHeight = $(document).height();
      var windowHeight = window.screen.height;
      var scrollPosY = $window.scrollTop();
      var $footerContainer = $('.site-footer__container');
      var footerHeight = $footerContainer.outerHeight(true) ; //- parseInt(footer.css('marginTop'))
      var footerScrollPosY = docHeight - footerHeight - windowHeight; //- (96 - 20)

      // if (scrollPosY >= footerScrollPosY) {
      //     $('.fixed-toast').hide();
      // } else {
      //     $('.fixed-toast').show();
      // }
  });
}

$(document).ready(function() {
  restriction();
  toast();
});


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/ntf-toast.js